/**
 * @file
 * Orientation webform: larger hit targets for button-style radios (AJAX-safe).
 *
 * Drupal provides globals when this library loads (dependencies: core/drupal).
 */

(function () {
  function zkOrientationBind(form) {
    form.addEventListener('click', (e) => {
      const label = e.target.closest(
        '.webform-options-display-buttons label.webform-options-display-buttons-label',
      );
      if (!label || !form.contains(label)) {
        return;
      }
      const item = label.closest('.form-item');
      const input = item?.querySelector('input[type="radio"]');
      if (input && input.type === 'radio' && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (typeof window !== 'undefined' && window.Drupal) {
    window.Drupal.behaviors.zkOrientationWebform = {
      attach(context) {
        const root = context && context.nodeType ? context : document;
        root
          .querySelectorAll(
            '.zk-orientation-webform-shell:not([data-zk-orientation-init]), .zk-orientation-webform:not([data-zk-orientation-init]), .zk-mediation-webform:not([data-zk-orientation-init])',
          )
          .forEach((form) => {
          form.setAttribute('data-zk-orientation-init', '1');
          zkOrientationBind(form);
        });
      },
    };
  }
})();
